(function () {
  var faceInput = document.getElementById('tryon-face-input');
  var uploadLabel = document.getElementById('tryon-upload-label');
  var facePreview = document.getElementById('tryon-face-preview');
  var generateBtn = document.getElementById('tryon-generate-btn');
  var statusEl = document.getElementById('tryon-status');
  var downloadBtn = document.getElementById('tryon-download-btn');
  var garmentUrl = document.getElementById('tryon-garment-url').value;

  var GENERATING_TEXT = generateBtn.dataset.generating || 'Generando...';
  var ERROR_TEXT = generateBtn.dataset.error || 'Algo fallo. Intenta con otra foto.';

  var faceBase64 = null;
  var ENDPOINT = 'https://probador-virtual-wx2h.onrender.com';

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function pollUntilDone(statusUrl, responseUrl) {
    var attempts = 0;
    function check() {
      return sleep(3000).then(function () {
        var url = ENDPOINT + '/check?status_url=' + encodeURIComponent(statusUrl) + '&response_url=' + encodeURIComponent(responseUrl);
        return fetch(url).then(function (r) { return r.json(); });
      }).then(function (data) {
        if (data.status === 'COMPLETED') {
          if (data.result_url) return data.result_url;
          throw new Error('Sin resultado');
        }
        if (data.status === 'FAILED') {
          throw new Error('La generacion fallo');
        }
        attempts = attempts + 1;
        if (attempts >= 60) {
          throw new Error('Tiempo de espera agotado');
        }
        return check();
      });
    }
    return check();
  }

  faceInput.addEventListener('change', function (e) {
    var file = e.target.files[0];
    if (!file) return;

    var reader = new FileReader();
    reader.onload = function () {
      faceBase64 = reader.result;
      facePreview.src = faceBase64;
      facePreview.style.display = 'block';
      uploadLabel.style.display = 'none';
      generateBtn.disabled = false;
      downloadBtn.style.display = 'none';
    };
    reader.readAsDataURL(file);
  });

  generateBtn.addEventListener('click', function () {
    if (!faceBase64) return;

    generateBtn.disabled = true;
    statusEl.textContent = GENERATING_TEXT;
    downloadBtn.style.display = 'none';

    fetch(ENDPOINT + '/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        face_image: faceBase64,
        garment_image_url: garmentUrl
      })
    })
    .then(function (submitRes) {
      if (!submitRes.ok) throw new Error('Error del servidor: ' + submitRes.status);
      return submitRes.json();
    })
    .then(function (submitData) {
      if (!submitData.status_url) throw new Error('No se pudo iniciar la generacion');
      return pollUntilDone(submitData.status_url, submitData.response_url);
    })
    .then(function (resultUrl) {
      facePreview.src = resultUrl;
      downloadBtn.onclick = function () { window.open(resultUrl, '_blank'); };
      downloadBtn.style.display = 'block';
      statusEl.textContent = '';
    })
    .catch(function (err) {
      console.error(err);
      statusEl.textContent = ERROR_TEXT;
    })
    .finally(function () {
      generateBtn.disabled = false;
    });
  });
})();